<template>
  <portal to="breadcrumb">
    <ul class="navbar-nav flex-row">
      <li>
        <div class="page-header">
          <nav class="breadcrumb-one" aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li v-for="(item, index) in nav" :key="index" :class="['breadcrumb-item', { active: index == nav.length - 1 }]">
                <span>{{ $t(item) }}</span>
              </li>
            </ol>
          </nav>
        </div>
      </li>
    </ul>
  </portal>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    nav: Array,
  },
};
</script>